'use client';

import React from 'react';
import { Avatar } from './Avatar';
import { StatusPill } from './StatusPill';
import { Clock } from './Money';

export interface AppointmentBusiness {
  name: string;
  logo?: string;
}

export interface AppointmentCardProps {
  business: AppointmentBusiness;
  serviceSummary: string; // "תספורת גבר · עיצוב גבות"
  provider?: string;
  date: string; // "היום" / "מחר"
  time: string; // "14:30"
  status?: 'confirmed' | 'pending' | 'cancelled' | 'completed' | 'noshow';
  onClick?: () => void;
  style?: React.CSSProperties;
}

export function AppointmentCard({
  business,
  serviceSummary,
  provider,
  date,
  time,
  status = 'confirmed',
  onClick,
  style = {},
}: AppointmentCardProps) {
  return (
    <div
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--sp-4)',
        padding: 'var(--sp-5)',
        background: 'var(--bg-surface)',
        border: '1px solid var(--border-subtle)',
        borderRadius: 'var(--r-lg)',
        boxShadow: 'var(--shadow-sm)',
        cursor: onClick ? 'pointer' : 'default',
        fontFamily: 'var(--font-sans)',
        ...style,
      }}
    >
      <Avatar src={business?.logo} name={business?.name} size={48} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--sp-3)',
            marginBottom: 2,
          }}
        >
          <span
            style={{
              fontSize: 'var(--fs-label)',
              fontWeight: 'var(--fw-semibold)' as React.CSSProperties['fontWeight'],
              color: 'var(--text-primary)',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {business?.name}
          </span>
          <StatusPill status={status} />
        </div>
        <div
          style={{
            fontSize: 'var(--fs-body)',
            color: 'var(--text-secondary)',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {serviceSummary}
        </div>
        <div style={{ fontSize: 'var(--fs-caption)', color: 'var(--text-tertiary)', marginTop: 4 }}>
          {provider && <span>{provider} · </span>}
          <span
            style={{
              color: 'var(--text-secondary)',
              fontWeight: 'var(--fw-medium)' as React.CSSProperties['fontWeight'],
            }}
          >
            {date} · <Clock value={time} />
          </span>
        </div>
      </div>
      <span style={{ color: 'var(--text-tertiary)', fontSize: 20, flex: '0 0 auto' }}>
        <span style={{ display: 'inline-block' }}>‹</span>
      </span>
    </div>
  );
}
